import React from "react";
import { useTranslation } from "react-i18next";
import { parseStockSnapshot } from "../../utils/stockPostingPresentation";
import "./StockPostingContextCard.css";
const fmt = (value, digits) => value == null || value === "" ? "—" : Number.isFinite(Number(value)) ? Number(value).toFixed(digits) : String(value);
export default function StockPostingContextCard({ snapshot, movementId, title, onOpenMovement }) {
  const { t } = useTranslation(["stock", "common"]);
  const saved = parseStockSnapshot(snapshot);
  const id = saved?.movement_id || movementId;
  if (!saved && !id) return null;
  const context = saved?.posting_context;
  const source = saved?.source_context || context?.source_context;
  const unit = saved?.stock_unit_code || "";
  function values(state) {
    const cost = state?.productCost;
    return <><dt>{t("stock:integration.quantity")}</dt><dd>{fmt(cost?.total_quantity, 6)} {unit}</dd>
      <dt>{t("stock:integration.average")}</dt><dd>{fmt(cost?.average_cost_net, 4)} PLN/{unit}</dd>
      <dt>{t("stock:integration.value")}</dt><dd>{fmt(cost?.total_value_net, 2)} PLN</dd>
      {(state?.balances || []).map(row => <React.Fragment key={row.location_id || row.id}><dt>{t("stock:integration.location")} #{row.location_id || row.id}</dt><dd>{fmt(row.quantity, 6)} {unit}</dd></React.Fragment>)}</>;
  }
  return <details className="stock-context-card"><summary>{title || t("stock:integration.postingResult")} · #{id || "—"} · {saved?.business_date || "—"}</summary>
    <p>{t("stock:integration.originalSnapshotNotice")}</p>
    {source && <p>{t(`stock:integration.modules.${source.module}`, { defaultValue: source.module })} · #{source.document_id || "—"}{source.line_id ? ` / #${source.line_id}` : ""} · {source.date_source}</p>}
    {context ? <div className="stock-context-card__grid">
      <section><h4>{t("stock:integration.beforeAtDate", { date: saved.business_date })}</h4><dl>{values(context.operation_before)}</dl></section>
      <section><h4>{t("stock:integration.afterAtDate", { date: saved.business_date })}</h4><dl>{values(context.operation_after)}</dl></section>
      <section><h4>{t("stock:integration.currentAtPosting")}</h4><dl>{values(context.current_after)}</dl></section>
    </div> : <p>{t("stock:integration.legacyResultUnavailable")}</p>}
    {id && onOpenMovement && <button type="button" className="btn btn-outline-secondary" onClick={() => onOpenMovement(id)}>{t("stock:integration.openEffectiveMovement")}</button>}
  </details>;
}
